import React, { Fragment, useState } from 'react';
import InputText from '../../../Common/InputText';
import MultiSelectBox from '../../../Common/MultiSelectBox/MultiSelectBox';
import { MAX_NUM_TASK_LINKS } from '../../../../constants/constants';

interface LinkComponentProps {
	baselineTask: object;
	onFormChange: Function;
	formFilters: object;
	currentTask: object;
}

//#TODO this is not saving the latest link, check out why.
export const LinksComponentForm = ({ baselineTask, onFormChange, formFilters, currentTask }: LinkComponentProps) => {
	const [links, setLinks] = useState([]);
	const [selectedFile, setSelectedFile] = useState({});
	const [newLink, setNewLink] = useState({
		name: '',
		url: '',
		isActive: false,
		ordinal: 0,
		isFile: false,
	});
	const [editIndex, setEditIndex] = useState(null);

	const addLink = () => {		
		if (links.length >= MAX_NUM_TASK_LINKS) {
			alert('clicked');
			return;
		}

		if (newLink.name && newLink.url) {
			setNewLink({ ...newLink, isActive: true, ordinal: links.length, isFile: false });
			const updatedLinks = [...links];
			if (editIndex !== null) {
				updatedLinks[editIndex] = newLink;
				setEditIndex(null);
			} else {
				updatedLinks.push(newLink);
			}
			setLinks(updatedLinks);
			setNewLink({ name: '', url: '' });
			console.log(updatedLinks);

			onFormChange('links', updatedLinks);
		}
	};

	const removeLink = (index) => {
		setLinks(links.filter((_, i) => i !== index));
	};

	const editLink = (index) => {
		setNewLink(links[index]);
		setEditIndex(index);
	};

	const addFileLink = () => {
		if (!selectedFile?.name || !selectedFile?.url || links.length >= MAX_NUM_TASK_LINKS) {
			return;
		}

		const newLink = {
			name: selectedFile.name,
			url: selectedFile.url,
			isActive: true,
			ordinal: 0,
			isFile: true,
		};

		const updatedLinks = [...links];

		if (editIndex !== null) {
			updatedLinks[editIndex] = newLink;
			setEditIndex(null);
		} else {
			updatedLinks.push(newLink);
		}

		setLinks(updatedLinks);
		setSelectedFile({});

		onFormChange('links', updatedLinks);
	};

	const onFileLinkChange = (url) => {
		const selectedFile = formFilters.subscriptionFiles.find((m) => m.url === url);
		setSelectedFile(selectedFile);
	};

	return (
		<Fragment>
			<div className='col-6'>
				<div className='card'>
					<div className='card-header d-flex justify-content-between card-title'>
						<span>Links</span>
						<button type='button' className='btn btn-link' onClick={addLink}>
							<i className='fa-regular fa-circle-plus'></i>
							<span className='mx-1'>Add Link</span>
						</button>
					</div>
					<div className='card-body'>
						<div className='inner-container'>
							<div className='input-section'>
								<InputText
									name='linkName'
									type='text'
									placeholder='Name your link'
									className='form-control'
									value={newLink.name}
									onChange={(e) => setNewLink({ ...newLink, name: e.target.value })}
								/>
							</div>
							<div className='input-section links-component'>
							<div className='form-group'>
								<div className='input-group'>
									<div className='input-group-prepend'>
										<span className='input-group-text'>https://</span>
									</div>
									<input
										name='linkUrl'
										type='text'
										className='form-control input-text new-link-input'
										value={newLink.url}
										onChange={(e) => setNewLink({ ...newLink, url: e.target.value })}
									/>
									<div className='icon-black' onClick={addLink}>
										<i className='fa-regular fa-check mt-1'></i>
									</div>
									</div>
								</div>
							</div>
							<div className='footer' style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
								{links.map((link, index) =>
									!link.isFile ? (
										<div
											key={index}
											className='link-row'
											style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', minHeight: '18px' }}>
											<div className='link' style={{ flex: 1, paddingTop: '5px' }}>
												<a href={link?.url.startsWith("http") ? link.url : `https://${link.url}`}  target="_blank" rel="noopener noreferrer">{link.name}</a>
											</div>
											<div className='link-actions' style={{ display: 'flex', gap: '10px' }}>
												<div className='icon-black' onClick={() => editLink(index)}>
													<i className='fa-light fa-pen-to-square'></i>
												</div>
												<div className='icon' onClick={() => removeLink(index)}>
													<span className='fa-light fa-trash-can'></span>
												</div>
											</div>
										</div>
									) : null
								)}
							</div>
						</div>
					</div>
				</div>
			</div>
			{/* SELECT EXISTING FILE */}
			<div className='col-6'>
				<div className='card'>
					<div className='card-header d-flex justify-content-between card-title'>
						<span>Files</span>
						<button type='button' className='btn btn-link' onClick={addFileLink}>
							<i className='fa-regular fa-circle-plus'></i>
							<span className='mx-1'>Add File</span>
						</button>
					</div>
					<div className='card-body'>
						<MultiSelectBox
							name='linkFile'
							label='Files'
							idField='url'
							valueField='name'
							options={formFilters.subscriptionFiles}
							placeholder='Select existing file or add new'
							selectedValues={selectedFile?.url || ''}
							errorMessage='Is required'
							onChange={onFileLinkChange}
							isMulti={false}
						/>
					</div>
					<div className='footer' style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
						{links.map((link, index) =>
							link.isFile ? (
								<div
									key={index}
									className='link-row'
									style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
									<div className='link' style={{ flex: 1 }}>
										{link.name}
									</div>
									<div className='link-actions' style={{ display: 'flex', gap: '5px' }}>
										<div className='icon-black' onClick={() => editLink(index)}>
											<i className='fa-light fa-pen-to-square'></i>
										</div>
										<div className='icon' onClick={() => removeLink(index)}>
											<span className='fa-light fa-trash-can'></span>
										</div>
									</div>
								</div>
							) : null
						)}
					</div>
				</div>
			</div>
		</Fragment>
	);
};
